module.exports = __webpack_public_path__ + "static/media/CMS-instructions.463fe127.png";


//////////////////
// WEBPACK FOOTER
// ./src/portfolio/thumbs/CMS-instructions.png
// module id = 612
// module chunks = 0